import {
  Radio as BaseRadio,
  RadioGroup as BaseRadioGroup,
  RadioGroupProps as BaseRadioGroupProps,
  RadioProps as BaseRadioProps,
  cn,
} from "@nextui-org/react";

export const RadioGroup = ({
  classNames,
  children,
  ...props
}: BaseRadioGroupProps) => {
  return (
    <BaseRadioGroup
      {...props}
      classNames={{
        wrapper: cn("w-full gap-3", classNames?.wrapper),
        ...classNames,
      }}
    >
      {children}
    </BaseRadioGroup>
  );
};

type RadioProps = BaseRadioProps & {
  isSelected: boolean;
  selectedValue: any;
};

export const Radio = ({
  children,
  value,
  isSelected,
  selectedValue,
  ...props
}: RadioProps) => {
  return (
    <BaseRadio
      value={value}
      data-is-selected={isSelected}
      classNames={{
        base: cn(
          "w-full max-w-full flex m-0 rounded-xl px-3 py-4 sm:px-4 sm:py-[18px] transition-all duration-300 bg-[#FFF]",
          "shadow-[0px_4px_4px_0.5px_rgba(0,0,0,0.05)] data-[selected='true']:shadow-md",
          !!selectedValue && !isSelected ? "opacity-70" : "opacity-100"
        ),
        wrapper: cn("w-4 h-4"),
        control: cn("w-1.5 h-1.5 bg-[var(--main-color)]"),
        label: cn(
          "text-base font-semibold font-kumbh-sans",
          !!selectedValue && !isSelected ? "text-zinc-500" : "text-zinc-800"
        ),
        labelWrapper: cn(
          "flex flex-row justify-between gap-2 items-center ml-2 w-full"
        ),
        description: cn(
          "text-sm p-2 bg-[var(--main-color)] text-[var(--continue-button-font)] rounded-lg text-zinc-800 font-medium transition-all duration-300 !font-kumbh-sans",
          !!selectedValue && !isSelected ? "bg-zinc-200" : ""
        ),
      }}
      {...props}
    >
      {children}
    </BaseRadio>
  );
};
